import * as React from "react";
import { graphql } from "gatsby";

import Breadcrumbs from "@components/Breadcrumbs";
import Seo from "@components/Seo";

import SortingGallery from "@page_components/gallery/SortingGallery";

function GalleryPage({ data }) {
  const gallery = {
    fullImages: data?.fullImages,
    thumbnails: data?.thumbnails,
  };
  const { seo } = data.seo_data.nodes[0];
  const breadcrumbs_data = [{ name: "Galeria", href: `/galeria` }];

  return (
    <>
      <Seo title={seo.title} description={seo.metaDesc} />
      <div className="gallery-page">
        <div className="container">
          <Breadcrumbs data={breadcrumbs_data} />

          <main>
            <h1> Galeria </h1>
            <SortingGallery gallery_data={gallery} context="Wszystkie" />
          </main>
        </div>
      </div>
    </>
  );
}

export default GalleryPage;

export const query = graphql`
  {
    thumbnails: allWpImage {
      nodes {
        pageGallery {
          gallery {
            sourceUrl
          }
        }
      }
    }
    fullImages: allWpImage {
      nodes {
        pageGallery {
          gallery {
            sourceUrl
          }
        }
      }
    }
    seo_data: allWpPage(filter: { title: { eq: "Galeria" } }) {
      nodes {
        seo {
          title
          metaDesc
        }
      }
    }
  }
`;
